import React, { useEffect, useState } from "react";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const check = () => setShow(!localStorage.getItem("feral_cookie_consent"));
    check();
    window.addEventListener("feral-cookie-reset", check);
    return () => window.removeEventListener("feral-cookie-reset", check);
  }, []);
  const choose = (v) => { localStorage.setItem("feral_cookie_consent", v); setShow(false); };
  if (!show) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-sm z-[60] bg-[#f2e5de] text-[#231f20] border border-[#2c6052]/15 shadow-2xl p-5 md:p-6" role="dialog" aria-label="Cookie consent" data-testid="cookie-banner">
      <p className="feral-serif text-xl mb-2">A quick word on cookies.</p>
      <p className="text-xs md:text-sm font-light text-[#231f20]/75 leading-relaxed">We use essential cookies to make the site work, and optional analytics cookies to understand how it's used. You can change your mind any time from the footer.</p>
      <div className="mt-5 flex gap-3">
        <button onClick={() => choose("all")} className="feral-header text-[11px] font-bold tracking-[0.2em] bg-[#2c6052] text-[#f2e5de] px-5 py-3 hover:bg-[#9b3d0a] transition-colors" data-testid="cookie-accept">Accept all</button>
        <button onClick={() => choose("essential")} className="feral-header text-[11px] font-bold tracking-[0.2em] border border-[#2c6052]/30 px-5 py-3 hover:border-[#2c6052] transition-colors" data-testid="cookie-essential">Essential only</button>
      </div>
    </div>
  );
};
